import React, { Component } from "react";
import "../../public/scss/ResearchComponent.scss";
import Header from './Header';
import Footer from "./Footer";

import {
      Container,
      Row,
      Col,
      Media,
      Button
    } from "reactstrap";

import TextWithImage from './snippets/TextWithImage';

import image1 from './../../public/images/research/1.jpeg';
import image2 from './../../public/images/research/2.jpeg';
import image3 from './../../public/images/research/3.jpeg';
import image4 from './../../public/images/research/4.jpeg';
import image5 from './../../public/images/research/5.jpeg';
import image6 from './../../public/images/research/6.jpeg';
import image7 from './../../public/images/research/7.jpeg';
import image8 from './../../public/images/research/8.jpeg';


class ResellersComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {

        }
    }

    openLighBox(index) {
        this.setState({
            photoIndex: index,
            isOpen: true
        })
    }

    componentDidMount() {
        document.title = "Resellers - Skillupz";
    }
    
    render() {
        
        return (
        // <DocumentMeta {...meta}>
            <div className="ResearchComponent ResellersComponent">

                <Header />

                    <div className="homeEdtech" style={{background: '#121625 center fixed / cover'}}>
                        <Container style={{textAlign: 'center'}}>
                            <Row>
                                <Col md={{ size: 6, offset: 3 }}>
                                    <h2>RESELLER PARTNERSHIP</h2>
                                </Col>
                            </Row>
                        </Container>
                    </div>

                    <div className="researchContent" style={{padding: '10vh 0'}}>
                        <Container style={{textAlign: 'left'}}>
                            <Row style={{paddingBottom: '10px'}}>
                                <Col md={{ size: 12 }}>
                                    <h2 style={{color: '#f8ab24', fontWeight: 'bold'}}>Have a look at what we do</h2>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={{size: 12}}>
                                    <img src="https://skillupz.com/wp-content/uploads/2019/01/1-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/2-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/3-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/4-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/5-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/6-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/7-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/8-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/9-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/10-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/11-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/12-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/13-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/14-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/15-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/16-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/17-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/18-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/19-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/20-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/21-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/22-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/23-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/24-min.jpg" width="100%" /><br/><img src="https://skillupz.com/wp-content/uploads/2019/01/25.jpg" width="100%" />
                                </Col>
                            </Row>
                            <Row>
                                <Col style={{textAlign: 'center'}}>
                                    <h1><a href="mailto:hello@skillupz.com">Hello@SkillUpz.com</a></h1>
                                    <h5><a className="downloadPDF" target="_new" href="https://skillupz.com/wp-content/uploads/2019/01/Introducing-SkillUpz-Media-kit-1.pdf" download=""><i className="fa fa-download" aria-hidden="true"></i> Download Corporate Profile</a></h5>
                                </Col>
                            </Row>
                            </Container>
                    </div>
                
                <Footer />
            </div>
        // </DocumentMeta>
        );
    }
}

export default ResellersComponent;